import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import logo from '../../assets/aakashlogo-white.svg'
import check from '../../assets/check.svg'
import { UPDATE_ACTIVE_SECTION } from '../../constants/actionTypes'
import './Thankyou.css'
import { ANTHE_EXAM_TYPES } from 'constants/examTypeConstants'

const mapStateToProps = (state) => ({
    queryparam: state.queryparam,
    antheData: state.antheData,
    instructions: state.instructions,
})

const mapDispatchToProps = (dispatch) => {
    return {
        setActiveSection: (payload) =>
            dispatch({ type: UPDATE_ACTIVE_SECTION, payload }),
    }
}

const Thankyou = (props) => {
    const [antheData, setAntheData] = useState(null)
    const { t, i18n } = useTranslation()
    let examName = JSON.parse(localStorage.getItem('examName'))
    const dateTime = antheData?.config_date?.split(' ')

    const title = props.instructions.testData?.title
        ? props.instructions.testData?.title[i18n.language]
        : ''

    useEffect(() => {
        setAntheData(props.antheData)
        props.setActiveSection(0)
    }, [])

    return (
        <div className="outer">
            <main className="thankyou_page">
                <img id="img_class" src={logo} alt="logo" />
                {props?.isPreview ? (
                    <article className="thankyou">
                        <h1 className="thankyou-text">{t(title)}</h1>
                        <img
                            className="thankyou-img"
                            src={check}
                            alt="thank you"
                            style={{ margin: '64px 0 40px' }}
                        />
                        <p className="success" style={{ fontSize: '20px' }}>
                            {t('Thank you for submitting the test!')}
                        </p>
                    </article>
                ) : (
                    <article className="thankyou">
                        <h2 className="exam-name">{examName[i18n.language]}</h2>
                        <img className="thankyou-img" src={check} alt="thank you" />
                        <h1 className="thankyou-text">
                            {antheData ? 'Thank you!' : t('Thank you!')}
                        </h1>
                        <div className="roll_no">
                            Roll No : {props.queryparam.roll_no}
                        </div>
                        <p className="success">
                            {antheData
                                ? 'Your test attempts have been submitted.'
                                : t('Your test attempts have been submitted.')}
                            <br />
                            {ANTHE_EXAM_TYPES.includes(
                                props.queryparam?.exam_type?.toLowerCase(),
                            ) || antheData
                                ? ''
                                : t(
                                      'Your results would be available in the Exam/Result sections after 4 hours once you log into your iacst account.',
                                  )}
                        </p>
                    </article>
                )}
            </main>
        </div>
    )
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Thankyou))
